import loglevel, { type Logger, type LogLevelDesc} from "loglevel";
import LogMessagePrefix from "loglevel-plugin-prefix";
const { VITE_LOG_LEVEL } = import.meta.env;

LogMessagePrefix.reg(loglevel);
LogMessagePrefix.apply(loglevel, {
    template: "[%t] %n.%l:",
    levelFormatter(level) {
        return level.toUpperCase();
    },
    nameFormatter(name) {
        return name || "global";
    },
    timestampFormatter(date) {
        return date.toISOString();
    }
});

const AppLogger: Logger = loglevel.getLogger("app");

AppLogger.setDefaultLevel("error");
if (VITE_LOG_LEVEL) {
    AppLogger.setLevel(VITE_LOG_LEVEL as LogLevelDesc, true);
    AppLogger.trace(`Logger level set to ${VITE_LOG_LEVEL}`);
}

export { AppLogger };

